import React from "react";
import { Medal, Star, Trophy } from "../Icons";
import BG1 from "../../assets/about-us/seed-fund.png";
import BG2 from "../../assets/about-us/ideal-winner.png";
import BG3 from "../../assets/about-us/competition-winner.png";

const awards = [
  {
    icon: Trophy,
    title: "Innovator Seed Fund",
    subtitle: "2023",
    src: BG1,
    description:
      "Grant of $35k awarded by the Higher Education Commission (HEC) and World Bank to the parent company (Robotics World), recognizing our excellence in educational technology and product innovation.",
  },
  {
    icon: Medal,
    title: "National Idea Bank",
    subtitle: "Regional Winner",
    src: BG2,
    description:
      "Honored by the Former President of Pakistan, Dr. Arif Alvi, for our visionary approach in digital education and immersive learning platforms.",
  },
  {
    icon: Trophy,
    title: "TIE Competition Winner",
    subtitle: "2023",
    src: BG3,
    description:
      "Winner of the TIE competition because of its innovative idea and approach in STEAM education.",
  },
];

const AwardsSection = () => {
  return (
    <section className="bg-white px-4 py-10 sm:px-6 sm:py-14 lg:px-8 lg:py-20">
      <div className="mx-auto max-w-[1728px]">
        <div className="mx-auto max-w-[1006px] text-center">
          <div className="inline-flex items-center gap-2 text-base font-bold text-[#111827] sm:gap-3 sm:text-lg lg:text-xl">
            <Star />
            Recognition & Awards
          </div>

          <h2 className="mt-4 text-[28px] font-bold leading-tight text-[#111827] sm:mt-5 sm:text-[32px] sm:leading-[38px] lg:text-[40px] lg:leading-[47px]">
            Accolades & Recognition
          </h2>

          <p className="mt-4 text-base leading-6 text-[#111827] sm:mt-[18px] sm:text-lg sm:leading-[23px] lg:text-xl">
            STEAM Minds has earned industry recognition and forged strong
            partnerships that reflect our commitment to innovation and impact.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:mt-10 min-[580px]:grid-cols-2 lg:mt-16 lg:grid-cols-3 lg:gap-6">
          {awards.map(({ icon: Icon, title, subtitle, description, src }) => (
            <article
              key={title}
              className="group relative overflow-hidden bg-[#923D8C] px-4 pb-8 pt-6 text-center text-white shadow-[0_18px_40px_rgba(17,24,39,0.16)] transition-colors duration-300 ease-out hover:bg-white hover:shadow-[0_24px_50px_rgba(17,24,39,0.18)] sm:px-6 sm:pb-10 sm:pt-8 lg:px-8 xl:px-14 xl:pb-14 xl:pt-[46px]"
            >
              <div className="flex flex-col items-center transition-opacity duration-300 ease-out group-hover:opacity-0">
                <div className="flex h-20 w-20 items-center justify-center overflow-hidden rounded-full bg-white transition-colors duration-300 ease-out group-hover:bg-transparent sm:h-[122px] sm:w-[122px]">
                  <div className="flex scale-[0.82] items-center justify-center transition-all duration-300 ease-out group-hover:scale-95 group-hover:opacity-0 sm:scale-100">
                    <Icon />
                  </div>
                </div>

                <h3 className="mt-4 text-xl font-bold leading-7 sm:mt-10 sm:text-2xl">
                  {title}
                </h3>
                <p className="mt-2 text-base leading-6 text-white sm:text-xl sm:leading-[23px]">
                  {subtitle}
                </p>
              </div>

              <p className="mt-5 text-base leading-6 text-white sm:mt-7 sm:text-lg sm:leading-[23px] lg:text-xl">
                {description}
              </p>

              <div className="pointer-events-none absolute inset-0 flex scale-95 items-center justify-center p-4 opacity-0 transition-all duration-300 ease-out group-hover:scale-100 group-hover:opacity-100">
                <img
                  src={src}
                  alt={title}
                  className="h-auto max-h-full w-auto max-w-full object-contain"
                />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardsSection;
